export const ACTION_TYPES = {
	LOAD_DATA : 'loadData',
	LOAD_CAMPAIGN: 'loadCampaign',
	LOAD_COMPONENT_DATA: 'loadComponentData',
	LOAD_FAQS: 'loadFaqs',
	LOAD_HOW_IT_WORKS: 'loadHowItWorks',
	LOAD_CATEGORIES: 'loadCategories',
	CHANGE_CATEGORY: 'changeCategory',
	LOAD_BRANDS: 'loadBrands',
	CHANGE_BRAND: 'changeBrand',
	LOAD_MODELS: 'loadModels',
	CHANGE_MODEL: 'changeModel',
	LOAD_COLORS: 'loadColors',
	LOAD_GENDERS: 'loadGenders',
	LOAD_STATES: 'loadStates',
	LOAD_QUALITY_TYPES: 'loadQualityTypes',
	LOAD_APPRAISAL: 'loadAppraisal',
	SEND_APPRAISAL: 'sendAppraisal',
	GET_BUYOUT_BONUSES: 'getBuyoutBonuses',
	LOAD_BUYOUT: 'loadBuyout',
	GET_BUYOUT_STATE: 'getBuyoutState',
	LOAD_PARTNERS: 'loadPartners',
	UPLOAD_RECEIPT: 'uploadReceipt',
	ORDER_PICKUP: 'orderPickup',
	EDIT_IMEI: 'editImei',
	LOAD_STATE_TYPES: 'loadStateTypes',
	RESET_DEVICE_FINDER: 'resetDeviceFinder',
	RESET_APPRAISAL: 'resetAppraisal',
	SET_APPRAISAL_RESULT: 'setAppraisalResult',
	EDIT_SELECTED_NEW_MODEL: 'editSelectedNewModel',
	DETERMINE_SELECTED_QUALITY: 'determineSelectedQuality',
}